import { useState } from 'react'
import { PmiStepEnum } from '../PmiEstimatedModule'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../types/rootState'
import { updateHomeLoan } from '../../../../actions/home'
import { selectHomeId } from '../../../../store/selectors/home'
import { Button, Form, Input } from '@homebot/shared-ui-swashbuckle'

export const MSG = defineMessages({
  payment: {
    id: 'Pmi.Estimated.yourMonthlyPmiPayment',
    defaultMessage: 'Your monthly PMI payment',
  },
  submit: {
    id: 'general.submit',
    defaultMessage: 'Submit',
  },
  cancel: {
    id: 'general.cancel',
    defaultMessage: 'Cancel',
  },
  validationPaymentExists: {
    id: 'Pmi.Estimated.validationPaymentExists',
    defaultMessage: 'Please enter a PMI payment amount',
  },
  validationPaymentIsZeroOrPositive: {
    id: 'Pmi.Estimated.validationPaymentIsZeroOrPositive',
    defaultMessage: 'PMI payment value must be positive or zero',
  },
})

export interface PmiEstimatedInputStepProps {
  setStep: (step: PmiStepEnum) => void
  setInProgress: (inProgress: boolean) => void
}

export const PmiEstimatedInputStep = ({
  setStep,
  setInProgress,
}: PmiEstimatedInputStepProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const homeId = useSelector(selectHomeId)
  const [payment, setPayment] = useState<string>('')
  const currentLoanId = useSelector<RootState, string | null>(
    state => state.pmi.estimatedLoanId
  )

  const handleSubmit = () => {
    setInProgress(true)
    setStep(PmiStepEnum.MortgageStep)

    dispatch(
      updateHomeLoan({
        pmiMonthly: payment,
        homeId: homeId,
        loanUuid: currentLoanId,
      })
    )
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        type='number'
        leftElement='$'
        value={payment}
        name='pmiPayment'
        placeholder='0.00'
        enterKeyHint='send'
        label={intl.formatMessage(MSG.payment)}
        onChange={e => {
          // avoid running parseFloat on empty string
          if (e.target.value === '') {
            setPayment('')
            return
          }
          const twoDecimalString = +parseFloat(e.target.value).toFixed(2)
          setPayment(twoDecimalString.toString())
        }}
        rules={{
          min: {
            value: 0,
            message: intl.formatMessage(MSG.validationPaymentIsZeroOrPositive),
          },
          required: {
            value: true,
            message: intl.formatMessage(MSG.validationPaymentExists),
          },
        }}
      />
      <Button
        type='submit'
        colorScheme='btn-primary'
        isDisabled={payment.length === 0}
        width={['100%', null, 'inherit']}
      >
        {intl.formatMessage(MSG.submit)}
      </Button>
      <Button
        type='button'
        marginTop={['spacing-200', null, 'spacing-0']}
        marginLeft={[null, null, 'spacing-200']}
        colorScheme='btn-secondary'
        width={['100%', null, 'inherit']}
        onClick={() => {
          setStep(PmiStepEnum.InitialStep)
        }}
      >
        {intl.formatMessage(MSG.cancel)}
      </Button>
    </Form>
  )
}
